// Polyfills for older and crappy browsers
import 'core-js'

import elementDataset from 'element-dataset'

// Localization
import 'shared/utils/i18n'

import Bluebird from 'bluebird'
import Model from './redux/models'
import accounting from 'accounting'
import cuid from 'cuid'

elementDataset()

window.Promise = Bluebird
window.Model = Model

// Booqable currently relies on accounting to be global
// for setting correct currency settings
window.accounting = accounting
window.cuid = cuid

// Bluebird config
window.Promise.config({
  warnings: false
})

window.Promise.onPossiblyUnhandledRejection((error) => {
  if (error && error?.message !== 'requestError') {
    throw error
  }
})
